{{ label }}
@if (info) {
  <cs-tooltip [text]="info" [title]="label" class="status-chip-info"></cs-tooltip>
}
